import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M3 18V16H8V18H3ZM3 13V11H11V13H3ZM3 8V6H21V8H3ZM17 20L21 16H18V11H16V16H13L17 20Z" }));
export {
  o as ReactComponent
};
